const cards = [
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20peach%20coral%20tones%20breaking%20news%20concept%20dynamic%20shapes%20exclamation%20marks%20modern%20minimalist%20digital%20art%20clean%20aesthetic&width=800&height=500&seq=mrds-card-01&orientation=landscape",
    tag: "最新爆料",
    title: "某顶流综艺录制现场突发状况，工作人员曝出惊人内幕",
    desc: "据现场知情人士透露，该节目因嘉宾突发矛盾导致录制中断，具体细节仍在进一步核实中。",
    time: "2小时前",
    hot: "1.2万热度",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20amber%20gold%20tones%20scandal%20reveal%20concept%20dramatic%20shapes%20modern%20minimalist%20digital%20art%20clean%20design&width=800&height=500&seq=mrds-card-02&orientation=landscape",
    tag: "黑料深扒",
    title: "网红翻车事件全记录：从爆红到塌房只用了三天",
    desc: "mrds独家整理该网红从走红到争议爆发的时间线，涉及多起不为人知的过往黑料。",
    time: "5小时前",
    hot: "9800热度",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20coral%20rose%20tones%20funny%20meme%20concept%20playful%20shapes%20laughing%20elements%20modern%20minimalist%20digital%20art%20clean&width=800&height=500&seq=mrds-card-03&orientation=landscape",
    tag: "擦边搞笑",
    title: "直播间翻车名场面合集：这些主播的即兴反应太绝了",
    desc: "网友投稿精选本周直播间的搞笑瞬间，每一个都是可以反复观看的快乐源泉。",
    time: "7小时前",
    hot: "8700热度",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20terracotta%20tones%20ranking%20list%20concept%20numbered%20shapes%20modern%20minimalist%20digital%20art%20clean%20design&width=800&height=500&seq=mrds-card-04&orientation=landscape",
    tag: "榜单看点",
    title: "本周mrds热门话题TOP10：榜首话题引发全网讨论",
    desc: "大赛每日更新榜单揭晓，本周最受关注的十个话题涵盖了娱乐圈、社会热点的方方面面。",
    time: "9小时前",
    hot: "7600热度",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20warm%20golden%20orange%20tones%20insider%20reveal%20concept%20magnifying%20glass%20shapes%20modern%20minimalist%20digital%20art%20clean&width=800&height=500&seq=mrds-card-05&orientation=landscape",
    tag: "独家深挖",
    title: "业内人匿名爆料：某大厂内部整顿的真相远比想象复杂",
    desc: "多位不愿具名的业内人士向mrds提供了独家线索，揭示了这场风波背后不为人知的博弈。",
    time: "11小时前",
    hot: "6500热度",
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            每日爆料
          </h2>
          <a href="#updates" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1">
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <a key={i} href="#about" className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-background-100 transition-colors duration-200 cursor-pointer">
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">{card.desc}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1 text-primary-500">
                    <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {card.hot}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
        {/* The 5th card hidden on some breakpoints? No, grid-cols-3 means 3 per row on lg, 2 on sm, so 5 cards = 2 rows + 1 centered */}
        <div className="hidden lg:block">
          {/* On lg (3 cols), card 5 is alone in row 2 - this is fine, it's centered by default in the last row */}
        </div>
      </div>
    </section>
  );
}